import './App.css';
import { Navigate, Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Navbar from './components/common/Navbar';
import FooterComponent from './components/common/FooterComponent';

import HomePage from './components/accessifyStore/HomePage';
import ContactUsPage from './components/infoHelp/ContactUsPage';
import AboutUsPage from './components/infoHelp/AboutUsPage';
import PrivacyPolicyPage from './components/infoHelp/PrivacyPolicyPage';
import TermsAndCondtionsPage from './components/infoHelp/TermsAndCondtionsPage';


import BlogPage from './components/accessifyStore/BlogPage';

import AuthenticationPage from './components/AuthenticationPage';
import ProtectedRoute from './components/protectedRoutes/ProtectedRoutes';
import AccountPage from './components/customer/AccountPage';
import CartPage from './components/customer/CartPage';


import StorePage from './components/accessifyStore/accessories/StorePage';
import ProductDetails from './components/accessifyStore/accessories/ProductDetails';

import ServicePage from './components/accessifyStore/services/ServicesPage';
import ServiceDetails from './components/accessifyStore/services/ServiceDetails';

import { ToastContainer } from 'react-toastify';

function App() {



  return (
    <Router>
      <ToastContainer />
      <Navbar />
      <div className="container mx-auto p-4">
        <Routes>
          <Route path="/" exact element={<HomePage />} />
          <Route path="/about" element={<AboutUsPage />} />
          <Route path="/contact" element={<ContactUsPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsAndCondtionsPage />} />

          <Route path="/blog" element={<BlogPage />} />


          <Route path="/store" element={<StorePage />} />
          <Route path="/productDetails" element={<ProductDetails />} />

          <Route path="/services" element={<ServicePage />} />
          <Route path="/serviceDetails" element={<ServiceDetails />} />



          <Route path="/auth" element={<AuthenticationPage />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/account" element={<AccountPage />} />
            <Route path="/cart" element={<CartPage />} />
          </Route>

          {/* Catch-all Route (Optional) */}

          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </div>
      <FooterComponent />
    </Router>
  );
}

export default App;
